// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet crm-public API
 * OpenAPI spec version: 1
 */

export type SUREbusinessCommonDomainAdviseurStatus =
  (typeof SUREbusinessCommonDomainAdviseurStatus)[keyof typeof SUREbusinessCommonDomainAdviseurStatus];

export const SUREbusinessCommonDomainAdviseurStatus = {
  Actief: 'Actief',
  Beeindigd: 'Beeindigd',
  Geblokkeerd: 'Geblokkeerd',
  Kandidaat: 'Kandidaat',
  Onbekend: 'Onbekend',
} as const;
